// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseLayout_wrapper__UukFI {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background: var(--background-primary);
}

.BaseLayout_popUp__-MV12 {
  width: 100%;
}

.BaseLayout_sidebar__Q4P4C {
  position: absolute;
  z-index: 999;
  height: 100%;
  max-width: 100%;
}

.BaseLayout_children__7PKxc {
  padding-left: 64px;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.BaseLayout_bottomNav__fdpJC {
  display: none;
}

.BaseLayout_updates__e3JpN {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.BaseLayout_updates__e3JpN > span {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.4;
  z-index: 1;
}
.BaseLayout_updates__e3JpN > div {
  background: var(--background-secondary);
  border: 1px solid var(--background-quaternary);
  padding: 15px;
  border-radius: 3px;
  position: relative;
  z-index: 2;
  min-width: 250px;
}
.BaseLayout_updates__e3JpN h3 {
  color: var(--text-primary);
  font-size: 0.9em;
  margin-bottom: 7px;
  font-weight: 500;
}
.BaseLayout_updates__e3JpN ul {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.BaseLayout_updates__e3JpN li {
  color: var(--text-secondary);
  font-size: 0.85em;
}

.BaseLayout_updatesUpdates__zldYl button {
  margin-top: 10px;
  background: var(--background-emphasis);
  color: var(--text-secondary);
  padding: 7px 20px;
  margin-top: 25px;
  border-radius: 3px;
  font-size: 0.8em;
}

.BaseLayout_updatesRefresh__XR\\+HN {
  width: 400px;
}
.BaseLayout_updatesRefresh__XR\\+HN p {
  color: var(--text-secondary);
  font-size: 0.85em;
  margin-top: 5px;
}
.BaseLayout_updatesRefresh__XR\\+HN header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BaseLayout_updatesRefresh__XR\\+HN header button {
  padding: 5px;
}

.BaseLayout_updateBtn__jTZZ3 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.BaseLayout_updateBtn__jTZZ3 button {
  margin-top: 10px;
  background: var(--default-primary);
  color: white;
  padding: 7px 20px;
  margin-top: 25px;
  border-radius: 3px;
  font-size: 0.8em;
}
.BaseLayout_updateBtn_cancel__1UcD9 {
  background: var(--background-emphasis) !important;
}

@media only screen and (max-width: 500px) {
  .BaseLayout_children__7PKxc {
    padding-left: 0;
    padding-bottom: 58px;
  }
  .BaseLayout_bottomNav__fdpJC {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid var(--border-secondary);
    z-index: 1000;
  }
  .BaseLayout_sidebar__Q4P4C {
    display: none;
  }
}
.BaseLayout_installPopup__E-12p {
  position: fixed;
  top: 60px;
  right: 20px;
  width: 350px;
  z-index: 1000;
  padding: 15px;
  border-radius: 5px;
  transition: 0.3s;
  background: var(--background-secondary);
}
.BaseLayout_installPopup__E-12p h1 {
  color: var(--text-primary);
  font-size: 0.96em;
}
.BaseLayout_installPopup__E-12p p {
  margin-top: 5px;
  color: var(--text-secondary);
  font-size: 0.85em;
}

.BaseLayout_installBtns__cO8cw {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.BaseLayout_installBtns__cO8cw button {
  padding: 9px 17px;
  border-radius: 3px;
  font-size: 0.8em;
}
.BaseLayout_installBtns_install__uNOHa {
  background: var(--default-primary);
  color: white;
  margin-right: 10px;
}
.BaseLayout_installBtns_close__lOlBZ {
  background: var(--background-quaternary);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/layouts/BaseLayout/BaseLayout.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;AACD;;AAEA;EACC,WAAA;AACD;;AAEA;EACC,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AACD;;AAEA;EACC,aAAA;AACD;;AAEA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;AACF;AAEC;EACC,uCAAA;EACA,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAAF;AAGC;EACC,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAKC;EACC,4BAAA;EACA,iBAAA;AAHF;;AAQC;EACC,gBAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AASA;EACC,YAAA;AAND;AAQC;EACC,4BAAA;EACA,iBAAA;EACA,eAAA;AANF;AASC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAPF;AASE;EACC,YAAA;AAPH;;AAYA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AATD;AAWC;EACC,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAYC;EACC,iDAAA;AAVF;;AAcA;EACC;IACC,eAAA;IACA,oBAAA;EAXA;EAcD;IACC,cAAA;IACA,eAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,6CAAA;IACA,aAAA;EAZA;EAeD;IACC,aAAA;EAbA;AACF;AAgBA;EACC,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;AAdD;AAgBC;EACC,0BAAA;EACA,iBAAA;AAdF;AAiBC;EACC,eAAA;EACA,4BAAA;EACA,iBAAA;AAfF;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AAhBD;AAkBC;EACC,iBAAA;EACA,kBAAA;EACA,gBAAA;AAhBF;AAmBC;EACC,kCAAA;EACA,YAAA;EACA,kBAAA;AAjBF;AAoBC;EACC,wCAAA;EACA,YAAA;AAlBF","sourcesContent":[".wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tz-index: 999;\n\twidth: 100%;\n\theight: 100vh;\n\tbackground: var(--background-primary);\n}\n\n.popUp {\n\twidth: 100%;\n}\n\n.sidebar {\n\tposition: absolute;\n\tz-index: 999;\n\theight: 100%;\n\tmax-width: 100%;\n}\n\n.children {\n\tpadding-left: 64px;\n\twidth: 100%;\n\theight: 100vh;\n\toverflow: auto;\n}\n\n.bottomNav {\n\tdisplay: none;\n}\n\n.updates {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 100vh;\n\tz-index: 9999;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t> span {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: black;\n\t\topacity: 0.4;\n\t\tz-index: 1;\n\t}\n\n\t> div {\n\t\tbackground: var(--background-secondary);\n\t\tborder: 1px solid var(--background-quaternary);\n\t\tpadding: 15px;\n\t\tborder-radius: 3px;\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tmin-width: 250px;\n\t}\n\n\th3 {\n\t\tcolor: var(--text-primary);\n\t\tfont-size: 0.9em;\n\t\tmargin-bottom: 7px;\n\t\tfont-weight: 500;\n\t}\n\n\tul {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2px;\n\t}\n\n\tli {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.85em;\n\t}\n}\n\n.updatesUpdates {\n\tbutton {\n\t\tmargin-top: 10px;\n\t\tbackground: var(--background-emphasis);\n\t\tcolor: var(--text-secondary);\n\t\tpadding: 7px 20px;\n\t\tmargin-top: 25px;\n\t\tborder-radius: 3px;\n\t\tfont-size: 0.8em;\n\t}\n}\n\n.updatesRefresh {\n\twidth: 400px;\n\n\tp {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.85em;\n\t\tmargin-top: 5px;\n\t}\n\n\theader {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\tbutton {\n\t\t\tpadding: 5px;\n\t\t}\n\t}\n}\n\n.updateBtn {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 10px;\n\n\tbutton {\n\t\tmargin-top: 10px;\n\t\tbackground: var(--default-primary);\n\t\tcolor: white;\n\t\tpadding: 7px 20px;\n\t\tmargin-top: 25px;\n\t\tborder-radius: 3px;\n\t\tfont-size: 0.8em;\n\t}\n\n\t&_cancel {\n\t\tbackground: var(--background-emphasis) !important;\n\t}\n}\n\n@media only screen and (max-width: 500px) {\n\t.children {\n\t\tpadding-left: 0;\n\t\tpadding-bottom: 58px;\n\t}\n\n\t.bottomNav {\n\t\tdisplay: block;\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tborder-top: 1px solid var(--border-secondary);\n\t\tz-index: 1000;\n\t}\n\n\t.sidebar {\n\t\tdisplay: none;\n\t}\n}\n\n.installPopup {\n\tposition: fixed;\n\ttop: 60px;\n\tright: 20px;\n\twidth: 350px;\n\tz-index: 1000;\n\tpadding: 15px;\n\tborder-radius: 5px;\n\ttransition: 0.3s;\n\tbackground: var(--background-secondary);\n\n\th1 {\n\t\tcolor: var(--text-primary);\n\t\tfont-size: 0.96em;\n\t}\n\n\tp {\n\t\tmargin-top: 5px;\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.85em;\n\t}\n}\n\n.installBtns {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 20px;\n\n\tbutton {\n\t\tpadding: 9px 17px;\n\t\tborder-radius: 3px;\n\t\tfont-size: 0.8em;\n\t}\n\n\t&_install {\n\t\tbackground: var(--default-primary);\n\t\tcolor: white;\n\t\tmargin-right: 10px;\n\t}\n\n\t&_close {\n\t\tbackground: var(--background-quaternary);\n\t\tcolor: white;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BaseLayout_wrapper__UukFI`,
	"popUp": `BaseLayout_popUp__-MV12`,
	"sidebar": `BaseLayout_sidebar__Q4P4C`,
	"children": `BaseLayout_children__7PKxc`,
	"bottomNav": `BaseLayout_bottomNav__fdpJC`,
	"updates": `BaseLayout_updates__e3JpN`,
	"updatesUpdates": `BaseLayout_updatesUpdates__zldYl`,
	"updatesRefresh": `BaseLayout_updatesRefresh__XR+HN`,
	"updateBtn": `BaseLayout_updateBtn__jTZZ3`,
	"updateBtn_cancel": `BaseLayout_updateBtn_cancel__1UcD9`,
	"installPopup": `BaseLayout_installPopup__E-12p`,
	"installBtns": `BaseLayout_installBtns__cO8cw`,
	"installBtns_install": `BaseLayout_installBtns_install__uNOHa`,
	"installBtns_close": `BaseLayout_installBtns_close__lOlBZ`
};
export default ___CSS_LOADER_EXPORT___;
